import React from "react";

// The little puzzle in the menu bar.
export default class GlowPuzzle extends React.Component {
   static box_count = 7;
   static levels = [2, 3, 4];
   static storage_key = "glowPuzzleProgress";

   constructor(props) {
      super(props);
      const saved = JSON.parse(localStorage.getItem(GlowPuzzle.storage_key)) || { level: 0, boxes: [] };
      const level = Math.min(saved.level, GlowPuzzle.levels.length);
      const states = GlowPuzzle.levels[level];
      const boxes = saved.boxes.length === GlowPuzzle.box_count ? saved.boxes : this.generate_boxes(states);
      this.state = {
         level,
         boxes,
         blinking: false
      };
      this.save_progress(level, boxes);
   }

   cycle_state(state, max) {
      return (state + 1) % max;
   }

   toggle_boxes(state, index, states) {
      const new_state = [...state];
      new_state[index] = this.cycle_state(new_state[index], states);
      if (index > 0) new_state[index - 1] = this.cycle_state(new_state[index - 1], states);
      if (index < state.length - 1) new_state[index + 1] = this.cycle_state(new_state[index + 1], states);
      return new_state;
   }

   generate_boxes(states) {
      if (states === 2) {
         return Array.from({ length: GlowPuzzle.box_count }, () => 0);
      } else {
         let boxes;
         do {
            boxes = Array.from({ length: GlowPuzzle.box_count }, () =>
               Math.floor(Math.random() * states)
            );
         } while (boxes.every((s) => s === states - 1)); // Not all solved.
         return boxes;
      }
   }

   is_solved() {
      const goal = GlowPuzzle.levels[this.state.level] - 1;
      return this.state.boxes.every((s) => s === goal);
   }

   save_progress(level, boxes) {
      localStorage.setItem(GlowPuzzle.storage_key, JSON.stringify({ level, boxes }));
   }

   handle_click(index) {
      if (this.is_solved() || this.state.blinking) return;
      const states = GlowPuzzle.levels[this.state.level];
      const boxes = this.toggle_boxes(this.state.boxes, index, states);
      this.setState({ boxes }, () => {
         if (this.is_solved()) {
            this.blink_boxes(() => {
               const next_level = this.state.level + 1;
               if (next_level < GlowPuzzle.levels.length) {
                  const new_boxes = this.generate_boxes(GlowPuzzle.levels[next_level]);
                  this.setState({ level: next_level, boxes: new_boxes, blinking: false });
                  this.save_progress(next_level, new_boxes);
               } else {
                  this.setState({ blinking: false });
                  this.save_progress(next_level, []);
               }
            });
         } else {
            this.save_progress(this.state.level, boxes);
         }
      });
   }

   blink_boxes(callback) {
      this.setState({ blinking: true });
      let count = 0;
      const interval = setInterval(() => {
         this.setState((prev) => ({ boxes: prev.boxes.map(() => (count % 2 === 0 ? -1 : GlowPuzzle.levels[prev.level] - 1)) }));
         count++;
         if (count > 5) {
            clearInterval(interval);
            callback();
         }
      }, 150);
   }

   render() {
      const { level, boxes } = this.state;
      if (level >= GlowPuzzle.levels.length) return null;

      const container_style = {
         display: "flex",
         alignItems: "center",
         justifyContent: "center",
         gap: "4px",
         marginTop: "2px",
         marginLeft: "15px",
         padding: "4px",
         borderRadius: "4px",
         position: "relative"
      };

      const box_style = (state) => {
         const base = "#444";
         const states = [base, "#666", "#999", "#ccc"];
         const color = state === -1 ? "#222" : states[state];
         return {
            width: "10px",
            height: "6px",
            borderRadius: "2px",
            backgroundColor: color,
            boxShadow: state === -1 ? "none" : `0 0 4px ${color}`,
            cursor: "pointer",
            transition: "all 0.2s ease-in-out"
         };
      };

      return (
         <div style={container_style}>
            {boxes.map((state, i) => (
               <div
                  key={i}
                  style={box_style(state)}
                  onClick={() => this.handle_click(i)}
               />
            ))}
         </div>
      );
   }
}
